import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import BannerList from "../../features/banner/BannerList";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import SearchBar from "../../components/SearchBar";
import { ENUM_ROUTES } from "../../RoutesEnum";
import {
  useDeleteBannerMutation,
  useLazyGetBannersQuery,
} from "../../services/banner";
import { showError } from "../../constants/toasts";
import { isValidInput } from "../../utils/validations";

const ManageBanner = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Banner</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Customers
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate(ENUM_ROUTES.ADD_BANNERS)}
            >
              <AddIcon /> Add
            </Button>
            <Button className="btn btn_grey">
              <DownloadIcon /> Export
            </Button>
          </div>
        </div>
        <BannerList
          searchTerm={searchTerm}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          setSearchTerm={setSearchTerm}
        />
      </div>
    </MainContainer>
  );
};

export default ManageBanner;
